import { Typography } from "@mui/material";
import { T } from "../../util/t";
import { ConfirmButton } from "./ConfirmButton";
import { UnpaidMenu } from "./UnpaidMenu";

export const Waitlisted = ({ entry }) => {
    if (entry.payment?.status === "pending")
        return (
            <UnpaidMenu entry={entry}>
                <Typography whiteSpace="nowrap">
                    <T>Awaiting payment</T>
                </Typography>
            </UnpaidMenu>
        );

    return <ConfirmButton entry={entry} />;
};
